/** Chemins de navigation de l'objet Champ complémentaire (fiche par objet sur route). */

/** Base de la page "Configuration des offres commerciales". */
export const ADDITIONAL_FIELD_ADMIN_BASE = '/admin/offres';

/** Onglet du dashboard correspondant au listing des champs complémentaires. */
export const ADDITIONAL_FIELD_TAB = 'champComplementaire';

/** Listing des champs complémentaires (onglet du dashboard). */
export const additionalFieldListPath = `${ADDITIONAL_FIELD_ADMIN_BASE}?tab=${ADDITIONAL_FIELD_TAB}`;

/** Fiche de création d'un champ complémentaire. */
export const additionalFieldCreatePath = `${ADDITIONAL_FIELD_ADMIN_BASE}/champ-complementaire/new`;

/** Fiche d'édition d'un champ complémentaire. */
export const additionalFieldFichePath = (id: string | number): string =>
    `${ADDITIONAL_FIELD_ADMIN_BASE}/champ-complementaire/${id}`;

/** Route enfant (relative à `admin/offres`) gérant création (`new`) et édition (`:id`). */
export const ADDITIONAL_FIELD_FICHE_ROUTE = 'champ-complementaire/:id';
